
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  GetCompanyByVatParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\GetCompanyByVatParameters.ts

export class GetCompanyByVatParameters {

  // string CompagnyId
  public CompagnyId?: string=null;

  // string VatNumber
  public VatNumber?: string=null;

  // string Siret
  public Siret?: string=null;

  // string Duns
  public Duns?: string=null;

  // string Token
  public Token?: string=null;

  // string[] CountryCodes
  public CountryCodes: string[]=[];
}